import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { AppSmallTabs } from "../Generic/AppSmallTabs";
import { AgencyMembershipStatus } from "./AgenciesListUtils";

const activeTabMap: { [tab in AgencyMembershipStatus]: number } = {
  Active: 0,
  Requested: 1,
  Terminated: 2,
};

const tabs = [
  translate(STRINGS.ACTIVE),
  translate(STRINGS.REQUESTED),
  translate(STRINGS.TERMINATED),
];

interface Props {
  activeTab: AgencyMembershipStatus;
  onClick: (tab: AgencyMembershipStatus) => void;
}

const AgenciesTabs = (props: Props) => {
  const handleClick = React.useCallback(
    (tabIndex: number) => {
      switch (tabIndex) {
        case activeTabMap.Active:
          return props.onClick.call(null, "Active");
        case activeTabMap.Requested:
          return props.onClick.call(null, "Requested");
        case activeTabMap.Terminated:
          return props.onClick.call(null, "Terminated");
        default:
          throw new Error(`unknown tabIndex ${tabIndex}`);
      }
    },
    [props.onClick]
  );

  return (
    <AppSmallTabs activeTab={activeTabMap[props.activeTab]} tabs={tabs} onClick={handleClick} />
  );
};

export default React.memo(AgenciesTabs);
